import React from 'react'
import Forgot from './ForgotPass'

const index = () =><Forgot/>

export default index